import styled from "styled-components"

export const TitleBar = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  h3 {
    margin: 0;
    color: #626262;
    padding-right: 8px;
  }
`

export const IceBreakerButtonContainer = styled.div`
  display: flex;
  gap: 12px;
`